// Utilidades compartidas de la lista de compra (pestaña del presupuesto y
// compra de la semana en Compras y Almacén).

// Botón "Pedir a <proveedor>" que crea una orden de compra (y su recepción):
// stock y recepción aparcados hasta tener la nave organizada; se reactiva aquí
// (true). Mientras, se pide con el PDF o el WhatsApp del pedido del proveedor.
export const MOSTRAR_CREAR_ORDEN = false;

export const TEXTO_ESTADO = {
  pendiente: 'Pendiente',
  pedido: 'Pedido',
  comprado: 'Comprado',
  recibido: 'Recibido',
  en_stock: 'En stock',
};

export const TONO_ESTADO = {
  pendiente: 'bg-[#FDF0DC] text-[#92400E]',
  pedido: 'bg-[#E7EEFB] text-[#1E3A8A]',
  comprado: 'bg-[#E3F3EC] text-[#0F5E43]',
  recibido: 'bg-[#E3F3EC] text-[#0F5E43]',
  en_stock: 'bg-[#EEF1EF] text-[#4A5A53]',
};

export const TEXTO_AVISO = {
  compartido: 'Paquete compartido',
  sin_proveedor: 'Sin proveedor',
  sin_unidad_compra: 'Sin paquete',
  lotes_caducan: 'Lotes caducan',
  stock_sin_lotes: 'Stock sin lotes',
  racion_sospechosa: 'Ración sospechosa',
  ya_pedido: 'Ya pedido',
  no_pedir_parcial: 'No pedir en parte',
};

export const NOTA_COSTE = 'Coste de compra por paquetes enteros; el Resumen de costes valora lo que se consume';

export const formatCantidad = (n) => (Number(n) || 0).toLocaleString('es-ES', { maximumFractionDigits: 2 });
export const conUnidad = (n, unidad) => `${formatCantidad(n)}${unidad ? ` ${unidad}` : ''}`;
export const formatEuros = (n) => (Number(n) || 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
export const ddmm = (iso) => (iso && String(iso).length >= 10 ? `${String(iso).slice(8, 10)}/${String(iso).slice(5, 7)}` : '');

const abreviarUnidadCompra = (u) => {
  const t = String(u || '').trim();
  if (!t || t.toLowerCase() === 'paquete') return 'paq.';
  return t;
};

// "3 paq. de 500 g" (o "2 ud"); vacío si no hay paquetes que comprar
export const textoPaquetesCorto = (l) => {
  if (l.paquetes === null || l.paquetes === undefined || !l.paquetes) return '';
  const cpuc = Number(l.cantidad_por_unidad_compra) || 1;
  if (cpuc !== 1) return `${l.paquetes} ${abreviarUnidadCompra(l.unidad_compra)} de ${formatCantidad(cpuc)} ${l.unidad || ''}`.trim();
  return `${l.paquetes} ${l.unidad || ''}`.trim();
};

// Entra en la compra (totales, PDF, WhatsApp): no está marcada "No pedir" y
// falta comprar o lleva una cantidad puesta a mano (aunque sea 0). Una línea ya
// pedida (`cubierta_por_pedido`) solo si le falta algo sobre lo pedido.
export const cuentaEnCompra = (l) => !l.no_pedir && (l.cubierta_por_pedido
  ? Number(l.falta_comprar) > 0
  : (!!l.manual || Number(l.falta_comprar) > 0));

// Coste con que una línea suma en la compra: el suyo; en una ya pedida con
// cantidad a mano, el de lo que falta sobre lo pedido (`complemento`)
export const costeEnCompra = (l) => (l.cubierta_por_pedido && l.manual
  ? Number((l.complemento || {}).coste_estimado) || 0
  : Number(l.coste_estimado) || 0);

// Se compra por paquetes enteros (si no, por peso o volumen en la unidad del ingrediente)
export const porPaquetes = (l) => (l.compra_por_paquetes !== undefined
  ? !!l.compra_por_paquetes
  : l.paquetes !== null && l.paquetes !== undefined);

// Lo que va junto al input de cantidad: "paq. de 24 ud", "ud" o "kg"
export const textoUnidadInput = (l) => {
  if (!porPaquetes(l)) return l.unidad || '';
  const cpuc = Number(l.cantidad_por_unidad_compra) || 1;
  if (cpuc !== 1) return `${abreviarUnidadCompra(l.unidad_compra)} de ${formatCantidad(cpuc)} ${l.unidad || ''}`.trim();
  return l.unidad || '';
};

// Pedido por día de entrega (proveedores con `pedido_por_dia`)
export const DIAS_SEMANA = ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'];
export const NOMBRE_DIA = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

// 0 = lunes ... 6 = domingo (null si no es una fecha)
export const diaSemana = (iso) => {
  if (!iso || String(iso).length < 10) return null;
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  return Number.isNaN(d.getTime()) ? null : (d.getDay() + 6) % 7;
};

// "lun 06/10" (o "sin fecha")
export const textoDia = (iso) => {
  const n = diaSemana(iso);
  return n === null ? 'sin fecha' : `${DIAS_SEMANA[n]} ${ddmm(iso)}`;
};

// Cantidad de un día de `por_dia`: "2 paq. de 24 ud", "1,5 kg" o "en stock"
export const textoCantidadDia = (l, d) => {
  const manual = d.paquetes_manual !== null && d.paquetes_manual !== undefined;
  if (!manual && !(Number(d.falta_comprar) > 0)) return 'en stock';
  if (d.paquetes === null || d.paquetes === undefined) return conUnidad(d.cantidad_compra, l.unidad);
  return textoPaquetesCorto({ ...l, paquetes: d.paquetes }) || conUnidad(d.cantidad_compra, l.unidad);
};

// "lun 06/10: 2 paq. de 24 ud · mar 07/10: en stock"
export const textoPorDia = (l) => (l.por_dia || []).map(d => `${textoDia(d.fecha)}: ${textoCantidadDia(l, d)}`).join(' · ');

// Fechas de entrega (dd/mm) de los días con algo que pedir de las líneas por día
export const fechasEntregaLineas = (lineas) => {
  const fechas = new Set();
  (lineas || []).forEach((l) => {
    if (!l.por_dia || !cuentaEnCompra(l)) return;
    l.por_dia.forEach((d) => {
      const manual = d.paquetes_manual !== null && d.paquetes_manual !== undefined;
      const cuenta = manual ? Number(d.cantidad_compra) > 0 : Number(d.falta_comprar) > 0;
      if (d.fecha_entrega && cuenta) fechas.add(String(d.fecha_entrega).slice(0, 10));
    });
  });
  return Array.from(fechas).sort();
};

// Aviso si el proveedor no entrega ese día (no bloquea)
export const avisoDiaSinEntrega = (iso, diasEntrega, nombre = 'El proveedor') => {
  const n = diaSemana(iso);
  if (n === null || !Array.isArray(diasEntrega) || diasEntrega.length === 0 || diasEntrega.includes(n)) return '';
  return `${nombre} no entrega los ${NOMBRE_DIA[n]}; entrega: ${diasEntrega.map(d => DIAS_SEMANA[d]).join(', ')}`;
};

// Fecha de entrega por defecto: víspera de la primera fecha, nunca antes de hoy (AAAA-MM-DD)
export const vispera = (fechas, hoy) => {
  const validas = (fechas || []).filter(Boolean).map(f => String(f).slice(0, 10)).sort();
  if (validas.length === 0) return hoy;
  const d = new Date(`${validas[0]}T12:00:00`);
  d.setDate(d.getDate() - 1);
  const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return iso < hoy ? hoy : iso;
};

// Móvil: pantalla estrecha o dedo como puntero
export const esDispositivoMovil = () => {
  if (typeof window === 'undefined') return false;
  try {
    return window.innerWidth < 768 || !!window.matchMedia?.('(pointer: coarse)')?.matches;
  } catch (e) {
    return window.innerWidth < 768;
  }
};

// Texto del pedido para WhatsApp en el móvil, donde copiar al portapapeles
// tras una llamada al servidor falla (Safari en iOS): menú de compartir del
// sistema y, si no lo hay (o lo bloquea), WhatsApp con el texto ya escrito.
// Devuelve null en escritorio (se copia como siempre), 'compartido',
// 'whatsapp' o 'cancelado' (el usuario cerró el menú de compartir).
export const compartirTextoMovil = async (texto) => {
  if (!esDispositivoMovil()) return null;
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ text: texto });
      return 'compartido';
    } catch (e) {
      if (e && e.name === 'AbortError') return 'cancelado';
      // NotAllowedError u otro: se abre WhatsApp directamente
    }
  }
  const url = `https://wa.me/?text=${encodeURIComponent(texto)}`;
  const ventana = window.open(url, '_blank', 'noopener');
  if (!ventana) window.location.href = url;
  return 'whatsapp';
};

export const copiarTexto = async (texto) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch (e) {
    // se intenta el método clásico
  }
  const area = document.createElement('textarea');
  area.value = texto;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch (e) {
    ok = false;
  }
  document.body.removeChild(area);
  return ok;
};

// Descarga la respuesta (blob) de axios como PDF (o HTML si el servidor no tiene WeasyPrint)
export const descargarRespuesta = (respuesta, nombreBase) => {
  const tipo = respuesta.headers?.['content-type'] || 'application/pdf';
  const esPdf = tipo.includes('pdf');
  const url = window.URL.createObjectURL(new Blob([respuesta.data], { type: tipo }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${nombreBase}.${esPdf ? 'pdf' : 'html'}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Safari en iOS lee el blob después del clic: se libera pasado un rato
  setTimeout(() => window.URL.revokeObjectURL(url), 30000);
};

// ── Aviso de pedidos que se quedan cortos (o sobran) ──
// `avisos` = respuesta de GET /lista-compra-v2/avisos-pedidos.

// Proveedores con cortos sin revisar (los únicos que abren el aviso al entrar)
export const proveedoresConCortos = (avisos) => (avisos?.proveedores || [])
  .filter(p => !p.revisado && (p.cortos || []).length > 0);

// "Compras: 2 pedidos ya hechos se han quedado cortos por eventos nuevos (Makro 3 ingredientes, CeSur 1)"
export const textoResumenAvisos = (proveedores) => {
  const lista = proveedores || [];
  const n = lista.length;
  if (n === 0) return '';
  const detalle = lista.map((p, i) => {
    const c = (p.cortos || []).length;
    return `${p.proveedor_nombre} ${c}${i === 0 ? (c === 1 ? ' ingrediente' : ' ingredientes') : ''}`;
  }).join(', ');
  return `Compras: ${n} ${n === 1 ? 'pedido ya hecho se ha quedado corto' : 'pedidos ya hechos se han quedado cortos'} por eventos nuevos (${detalle})`;
};

// Compras y Almacén > Compra de la semana con el rango del aviso, el proveedor y "Solo lo que falta"
export const urlVerDiferencia = (avisos, proveedorId) => {
  const params = new URLSearchParams();
  if (avisos?.desde) params.set('desde', avisos.desde);
  if (avisos?.hasta) params.set('hasta', avisos.hasta);
  if (proveedorId) params.set('proveedor', proveedorId);
  params.set('solo_falta', '1');
  return `/compras/necesidades?${params.toString()}`;
};

// Parámetros de la URL que lee la compra de la semana ({desde, hasta, proveedor, soloFalta}; null si no vienen)
export const leerParametrosCompraSemana = (search) => {
  const params = new URLSearchParams(search || '');
  const fecha = (v) => (/^\d{4}-\d{2}-\d{2}$/.test(v || '') ? v : null);
  return {
    desde: fecha(params.get('desde')),
    hasta: fecha(params.get('hasta')),
    proveedor: params.get('proveedor') || null,
    soloFalta: params.get('solo_falta') === '1',
  };
};

// Texto de la foto de lo pedido de una línea: "pedido 1 paquete el 05/10" (o la
// cantidad en su unidad si no se compra por paquetes). null si no hay foto.
export const textoFotoPedido = (l) => {
  if (!l || !l.pedido_en || !['pedido', 'comprado', 'recibido'].includes(l.estado)) return null;
  const fecha = String(l.pedido_en).slice(0, 10);
  const dia = /^\d{4}-\d{2}-\d{2}$/.test(fecha) ? `${fecha.slice(8, 10)}/${fecha.slice(5, 7)}` : '';
  const paq = Number(l.pedido_paquetes);
  let que;
  if (Number.isFinite(paq) && paq > 0 && l.unidad_compra) {
    const uc = String(l.unidad_compra);
    const plural = paq === 1 || uc.endsWith('s') ? uc : uc + ('lrnd'.includes(uc.slice(-1)) ? 'es' : 's');
    que = `${paq} ${plural}`;
  } else if (l.pedido_cantidad != null) {
    que = `${Number(l.pedido_cantidad)} ${l.unidad || ''}`.trim();
  } else return null;
  return `pedido ${que}${dia ? ` el ${dia}` : ''}`;
};

// Compra de la semana: texto de lo pedido de una línea sumando sus partes:
// "pedido 2 paq. el 05/10 · Alfonso". Usa `pedido_paquetes_total` o, si es null,
// `pedido_total` en la unidad del ingrediente; fecha de `ultimo_pedido_en`.
// null si la línea no está pedida, comprada ni recibida o no hay nada pedido.
export const textoFotoSemana = (l) => {
  if (!l || !['pedido', 'comprado', 'recibido'].includes(l.estado)) return null;
  const paq = l.pedido_paquetes_total;
  let que = '';
  if (paq !== null && paq !== undefined && Number(paq) > 0) {
    const uc = abreviarUnidadCompra(l.unidad_compra).replace(/^paq\.$/, 'paq');
    const plural = Number(paq) === 1 || uc === 'paq' || uc.endsWith('s') ? uc : uc + ('lrnd'.includes(uc.slice(-1)) ? 'es' : 's');
    que = `${formatCantidad(paq)} ${plural}`;
  } else if (Number(l.pedido_total) > 0) {
    que = conUnidad(l.pedido_total, l.unidad);
  }
  const fecha = ddmm(l.ultimo_pedido_en);
  if (!que && !fecha) return null;
  const partes = [`pedido${que ? ` ${que}` : ''}${fecha ? ` el ${fecha}` : ''}`];
  if (l.pedido_por) partes.push(l.pedido_por);
  return partes.join(' · ');
};

// Lo pedido de más o de menos a propósito al marcar (`pedido_ajuste_paquetes` o,
// si es null, `pedido_ajuste` en la unidad de la línea): "+1 paq de reserva" o
// "1 paq menos a propósito". null si es 0 o no hay ajuste.
export const textoAjustePedido = (l) => {
  if (!l) return null;
  const enPaquetes = l.pedido_ajuste_paquetes !== null && l.pedido_ajuste_paquetes !== undefined;
  const valor = Number(enPaquetes ? l.pedido_ajuste_paquetes : l.pedido_ajuste);
  if (!Number.isFinite(valor) || valor === 0) return null;
  const que = enPaquetes ? `${formatCantidad(Math.abs(valor))} paq` : conUnidad(Math.abs(valor), l.unidad);
  return valor > 0 ? `+${que} de reserva` : `${que} menos a propósito`;
};

const PLURAL_ESTADO_PARTE = {
  pendiente: ['pendiente', 'pendientes'],
  pedido: ['pedida', 'pedidas'],
  comprado: ['comprada', 'compradas'],
  recibido: ['recibida', 'recibidas'],
  en_stock: ['en stock', 'en stock'],
};

// "2 partes pedidas, 1 pendiente" a partir de `estados_partes` ({estado: n})
export const textoEstadosPartes = (estadosPartes) => {
  const orden = ['pedido', 'comprado', 'recibido', 'pendiente', 'en_stock'];
  const claves = Object.keys(estadosPartes || {})
    .filter(k => Number(estadosPartes[k]) > 0)
    .sort((a, b) => (orden.indexOf(a) === -1 ? 99 : orden.indexOf(a)) - (orden.indexOf(b) === -1 ? 99 : orden.indexOf(b)));
  return claves.map((k, i) => {
    const n = Number(estadosPartes[k]);
    const [uno, varios] = PLURAL_ESTADO_PARTE[k] || [k, k];
    const texto = n === 1 ? uno : varios;
    if (i === 0) return `${n} ${n === 1 ? 'parte' : 'partes'} ${texto}`;
    return `${n} ${texto}`;
  }).join(', ');
};
